<template>
  <div class="card ml-20 mr-20" style="height: 100vh">
    <div class="card-header">
      <div class="card-header">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <a href="javascript:void(0)">LXD</a>
            </li>
            <li class="breadcrumb-item">
              <a href="javascript:void(0)">Create Instance</a>
            </li>
          </ol>
        </nav>
      </div>
    </div>
    <div class="card-body">
      <div class="row">
        <template v-if="!showSuccess">
          <div class="col-md-12 d-flex justify-content-center align-items-center">
            <h5 class="fw-600">Create Instance</h5>
          </div>
          <div class="col-md-3">
          </div>
          <div class="col-md-6">
            <form class="form-horizontal" @submit.prevent="submitForm">
              <div class="row">
                <label class="col-md-3 col-form-label">Instance Type</label>
                <div class="col-md-9">
                  <div class="form-group">
                    <select v-model="instanceType" class="form-control" @change="onInstanceTypeChange">
                      <option disabled value="">Select</option>
                      <option value="container">Container</option>
                      <option value="virtual-machine">Virtual Machine</option>
                    </select>
                  </div>
                </div>
              </div>

              <!-- Container Form -->
              <template v-if="instanceType === 'container'">
                <div class="row">
                  <label class="col-md-3 col-form-label">Name*</label>
                  <div class="col-md-9">
                    <div class="form-group">
                      <input v-model="form.name" class="form-control"
                             placeholder="Name" required type="text">
                    </div>
                  </div>
                </div>
                <div class="row">
                  <label class="col-md-3 col-form-label">Hostname*</label>
                  <div class="col-md-9">
                    <div class="form-group">
                      <input v-model="form.hostname" class="form-control" placeholder="Hostname" required type="text">
                    </div>
                  </div>
                </div>
                <div class="row">
                  <label class="col-md-3 col-form-label">Image</label>
                  <div class="col-md-9">
                    <div class="form-group">
                      <select v-model="form.image" class="form-control">
                        <option disabled value="">Select</option>
                        <option value="wpo">WPO</option>
                        <option value="alma9-bs">Alma 9</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <label class="col-md-3 col-form-label">Profile*</label>
                  <div class="col-md-9">
                    <div class="form-group">
                      <select v-model="form.profile" class="form-control">
                        <option disabled value="">Select</option>
                        <option value="wpo-starter">WPO Starter</option>
                        <option value="wpo-pro">WPO Professional</option>
                        <option value="wpo-business">WPO Business</option>
                        <option value="wpo-enterprise">WPO Enterprise</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <label class="col-md-3 col-form-label">Cluster*</label>
                  <div class="col-md-9">
                    <div class="form-group">
                      <select v-model="cluster" class="form-control">
                        <option disabled value="">Select</option>
                        <option value="lx4">LX4 (Testing)</option>
                        <option value="ord">ORD (Production)</option>
                        <option value="egv">EGV (Production)</option>
                        <option value="iad">IAD (Production)</option>
                      </select>
                    </div>
                  </div>
                </div>
              </template>

              <!-- Virtual Machine Form -->
              <template v-if="instanceType === 'virtual-machine'">
                <div class="row">
                  <label class="col-md-3 col-form-label">Name*</label>
                  <div class="col-md-9">
                    <div class="form-group">
                      <input v-model="vmForm.name" class="form-control"
                             placeholder="Name" required type="text">
                    </div>
                  </div>
                </div>
                <div class="row">
                  <label class="col-md-3 col-form-label">Image*</label>
                  <div class="col-md-9">
                    <div class="form-group">
                      <input v-model="vmForm.image" class="form-control" readonly>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <label class="col-md-3 col-form-label">Profile*</label>
                  <div class="col-md-9">
                    <div class="form-group">
                      <select v-model="vmForm.profile" class="form-control">
                        <option disabled value="">Select</option>
                        <option value="vps1-vm">vps1-vm</option>
                        <option value="vps2-vm">vps2-vm</option>
                        <option value="vps3-vm">vps3-vm</option>
                        <option value="vps4-vm">vps4-vm</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <label class="col-md-3 col-form-label">Cluster*</label>
                  <div class="col-md-9">
                    <div class="form-group">
                      <select v-model="vmForm.cluster" class="form-control">
                        <option disabled value="">Select</option>
                        <option value="ORD">ORD</option>
                        <option value="EGV">EGV</option>
                        <option value="IAD">IAD</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <label class="col-md-3 col-form-label">Service ID</label>
                  <div class="col-md-9">
                    <div class="form-group">
                      <input v-model="vmForm.serviceId" class="form-control"
                             placeholder="Service ID (optional, numbers only)"
                             type="text"
                             @input="validateServiceId">
                    </div>
                  </div>
                </div>
                <div class="row">
                  <label class="col-md-3 col-form-label">Hostname*</label>
                  <div class="col-md-9">
                    <div class="form-group">
                      <input v-model="vmForm.hostname" class="form-control" placeholder="Hostname" required type="text">
                    </div>
                  </div>
                </div>
              </template>

              <div class="row">
                <div class="col-md-3"></div>
                <div class="col-md-9 d-flex justify-content-end align-items-center">
                  <button :disabled="loading" class="btn btn-info pull-right" type="submit">
                    <i v-if="loading" class="fa fa-spin fa-spinner"></i>
                    <span v-else>Create</span>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </template>
        <div v-if="showSuccess" class="col-md-12">
          <svg class="checkmark" viewBox="0 0 52 52">
            <circle class="checkmark-circle" cx="26" cy="26" fill="none" r="25"/>
            <path class="checkmark-check" d="M14 27l7 7 16-16" fill="none"/>
          </svg>
          <h4 class="text-center fw-600">Instance Created Successfully</h4>
          <p class="text-center">
            Press a button below to either create a new instance or view the current instance you just created.
          </p>
          <div class="d-flex justify-content-center">
            <button class="btn btn-outline-info" @click="openForm">Create New Instance</button>
            <button class="ml-20 btn btn-danger btn-outline-danger"
                    @click="viewCurrentInstance">View Current Instance
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="card-footer">
      <div class="row">

      </div>
    </div>
  </div>
</template>

<script>
import {db} from "@/firebase/init";

export default {
  name: "create.vue",
  data() {
    return {
      showSuccess: false,
      loading: false,
      instanceType: '',
      cluster: 'lx4',
      form: {
        name: '',
        hostname: '',
        image: 'wpo',
        profile: 'wpo-starter',
      },
      vmForm: {
        name: '',
        hostname: '',
        image: 'alma9-vm',
        profile: '',
        cluster: '',
        serviceId: ''
      }
    }
  },
  methods: {
    onInstanceTypeChange() {
      // Reset forms when instance type changes
      this.form = {
        name: '',
        hostname: '',
        image: 'wpo',
        profile: 'wpo-starter',
      };
      this.vmForm = {
        name: '',
        hostname: '',
        image: 'alma9-vm',
        profile: '',
        cluster: '',
        serviceId: ''
      };
      this.cluster = 'lx4';
    },
    validateServiceId(event) {
      // Only allow numbers
      const value = event.target.value;
      const numericValue = value.replace(/[^0-9]/g, '');
      this.vmForm.serviceId = numericValue;
    },
    openForm() {
      this.showSuccess = false;
      this.instanceType = '';
      this.form.name = '';
      this.form.hostname = '';
      this.vmForm = {
        name: '',
        hostname: '',
        image: 'alma9-vm',
        profile: '',
        cluster: '',
        serviceId: ''
      };
    },
    viewCurrentInstance() {
      const instanceName = this.instanceType === 'virtual-machine' ? this.vmForm.name : this.form.name;
      const instanceCluster = this.instanceType === 'virtual-machine' ? this.vmForm.cluster.toLowerCase() : this.cluster;
      localStorage.setItem('cluster', instanceCluster);
      this.$router.push({name: 'lxd-details', params: {id: instanceName}});
    },
    async submitForm() {
      try {
        if (!this.instanceType) {
          this.showToast({
            message: 'Please select an instance type',
            duration: 2000
          }, true, 'danger');
          return;
        }

        if (this.instanceType === 'container') {
          if (!this.form.name || !this.form.hostname) {
            return;
          }
        } else if (this.instanceType === 'virtual-machine') {
          if (!this.vmForm.name || !this.vmForm.profile || !this.vmForm.cluster) {
            this.showToast({
              message: 'Please fill in all required fields',
              duration: 2000
            }, true, 'danger');
            return;
          }
        }

        this.loading = true;
        
        let submitData = {};
        let submitCluster = '';
        
        if (this.instanceType === 'container') {
          submitData = { ...this.form };
          submitCluster = this.cluster;
        } else if (this.instanceType === 'virtual-machine') {
          submitData = {
            name: this.vmForm.name,
            image: this.vmForm.image,
            profile: this.vmForm.profile,
            hostname: this.vmForm.hostname,
          };
          submitCluster = this.vmForm.cluster.toLowerCase();
        }

        const resp = await this.$http.post('/lxd/instance/action', {
          action: 'create',
          data: submitData,
          cluster: submitCluster,
          grant_type: 'token'
        });
        if(this.instanceType === 'virtual-machine' && this.vmForm.serviceId) {
          await db.collection('virtualMachineInstances').add({ serviceId: this.vmForm.serviceId, instance: this.vmForm.name})
        }
        if (resp.data.success) {
          this.showSuccess = true;
        } else {
          this.showToast({
            message: `Something went wrong while creating instance. ${resp.data.message || 'Unknown error'}`,
            duration: 2000
          }, true, 'danger');
        }
      } catch (e) {
        console.log(e);
        this.showToast({
          message: `Something went wrong while creating instance. ${e.toString()}`,
          duration: 2000
        }, true, 'danger');
      } finally {
        this.loading = false;
      }
    }
  }
}
</script>


<style scoped>
/* Animated Checkmark */
.checkmark {
  width: 100px;
  height: 100px;
  margin: 0 auto;
  stroke-width: 3;
  stroke: #22c55e;
  stroke-miterlimit: 10;
  border-radius: 50%;
  display: block;
}

.checkmark-circle {
  stroke-dasharray: 157;
  stroke-dashoffset: 157;
  stroke: #22c55e;
  animation: circleDraw 0.7s ease-in-out forwards;
}

.checkmark-check {
  stroke-dasharray: 48;
  stroke-dashoffset: 48;
  stroke: #22c55e;
  animation: checkDraw 0.5s ease-in-out forwards;
  animation-delay: 0.7s;
}

@keyframes circleDraw {
  to {
    stroke-dashoffset: 0;
  }
}

@keyframes checkDraw {
  to {
    stroke-dashoffset: 0;
  }
}

@keyframes pop {
  0% {
    transform: scale(0.8);
    opacity: 0;
  }
  60% {
    transform: scale(1.05);
    opacity: 1;
  }
  100% {
    transform: scale(1);
  }
}

label {
  font-weight: bold;
  color: gray;
}
</style>
